import * as yup from "yup";

export const petStoreSchema = yup.object().shape({
  title: yup.string().required("Title is required"),
  play_sku_id: yup.string().required("Play SKU ID is required"),
  apple_sku_id: yup.string().required("Apple SKU ID is required"),
  description: yup.string().required("Description is required"),
  price: yup
    .number()
    .typeError("Price must be a number")
    .required("Price is required"),
  points: yup
    .number()
    .typeError("Points must be a number")
    .required("Points are required"),
  image: yup.string().required("Image is required"),

  consent: yup.boolean().when("price", (price, schema, { context }) => {
    const defaultPrice = context?.defaultPrice ?? "";
    const hasChanged = price !== defaultPrice;
    return hasChanged
      ? schema.oneOf([true], "Consent is required when price is changed")
      : schema.notRequired();
  }),
});
